import { SelectProps } from "antd";
import SelectParam from "../../../../../components/params/select/select-params";
import { SEARCH_PARAMS } from "../../../../../constants/searchParams";

export const PENDING_STATUS = "pending";
export const APPROVED_STATUS = "approved";
export const REJECTED_STATUS = "rejected";
export const REVOKED_STATUS = "revoked";

interface SelectStatusParamProps extends SelectProps {
  paramKey?: string;
  showRevoked?: boolean;
}

const options = [
  {
    label: "Chờ duyệt",
    value: PENDING_STATUS,
  },
  {
    label: "Đã duyệt",
    value: APPROVED_STATUS,
  },
  {
    label: "Từ chối",
    value: REJECTED_STATUS,
  },
  {
    label: "Thu hồi",
    value: REVOKED_STATUS,
  },
];

const SelectStatusParam = (props: SelectStatusParamProps) => {
  const { paramKey, showRevoked, ...rest } = props;
  const paramsKey = paramKey || "status";

  const filteredOptions = showRevoked
    ? options
    : [
        {
          label: "Yêu cầu cần duyệt",
          value: PENDING_STATUS,
        },
        {
          label: "Yêu cầu đã xử lý",
          value: APPROVED_STATUS,
        },
      ];

  return (
    <SelectParam
      size="large"
      style={{
        width: "200px",
      }}
      className="mt-2"
      paramsKey={paramsKey as keyof typeof SEARCH_PARAMS}
      options={filteredOptions}
      allowClear
      placeholder="Trạng thái"
      isSetDefault={Boolean(rest.defaultValue)}
      {...rest}
    />
  );
};

export default SelectStatusParam;
